import React, { useState } from 'react';

const PartnershipFirm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with Partnership Firm registration.',
    website_hp: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with  Partnership Firm registration.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Partnership Firm Regn.
            </h1>
            <p className="mt-4 text-xl text-blue-100">
              The simplest structure for a group of people starting a business together.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">👥</span> Start Firm Registration Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Registration Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of Partnership Firm
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                A Partnership Firm is a business structure where two or more individuals agree to share the profits or losses of a business carried on by all or any of them acting for all. It is governed by the Indian Partnership Act, 1932. Registration is optional but highly recommended to acquire a separate legal identity for better legal standing and enforceability.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Shared Capital & Expertise:</strong> Allows pooling of financial resources and management skills from multiple partners.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Partnership Deed:</strong> The relationship, rights, and duties are clearly defined in a formal, legal agreement, reducing potential disputes.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Easy Formation & Compliance:</strong> Easier to form and fewer statutory compliance requirements compared to companies.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Legal Recognition (On Registration):</strong> Registered firms gain the power to sue and be sued in the firm's name.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                <input type="text" name="website_hp" value={formData.website_hp} onChange={handleInputChange} style={{ display: 'none' }}/>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with Startup registration." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Simple Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for Partnership Firm Registration
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-6 grid-flow-row-dense">
            {[
              { number: "01", icon: "📊", title: "Information Collection", desc: "Collect details and consent from all intended partners." },
              { number: "02", icon: "📝", title: "Drafting Partnership Deed", desc: "Drafting the legal agreement defining partner rights and duties." },
              { number: "03", icon: "🖋️", title: "Deed Notarization & Stamping", desc: "Notarizing and paying requisite stamp duty on the deed." },
              { number: "04", icon: "🆔", title: "Apply for PAN/TAN", desc: "Application for a separate Permanent Account Number (PAN) in the firm's name." },
              { number: "05", icon: "🏢", title: "R-O-F Application (Optional)", desc: "Filing Form A/B with the Registrar of Firms (ROF) for formal registration." },
              { number: "06", icon: "💳", title: "Bank Account Setup", desc: "Open a bank account in the name of the Partnership Firm using the firm's PAN." },
              { number: "07", icon: "📄", title: "GST Application (If Required)", desc: "Applying for Goods & Service Tax (GST) registration if the business crosses the threshold limit." },
              { number: "08", icon: "📬", title: "Final Document Delivery", desc: "Delivery of the final Partnership Deed, Firm PAN, and other certificates." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 p-4 bg-white rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow border-t-4 border-blue-500 h-full">
                <div className="procedure-step-content">
                  <div>
                    <span className="text-2xl font-extrabold text-blue-600 block mb-2">{step.number}</span>
                    <span className="text-2xl mx-auto mb-2 block">{step.icon}</span>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{step.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm mt-3">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Only Scanned Copies are required
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for Registration
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "🤝", title: "Signed Partnership Deed", desc: "Duly stamped and notarized Partnership Deed document." },
              { icon: "👥", title: "Partners' PAN & Identity Proof", desc: "PAN Card and Aadhaar Card/Voter ID of all partners." },
              { icon: "🏠", title: "Partners' Address Proof", desc: "Bank Statement, Mobile bill, or Telephone bill (less than 2 months old)." },
              { icon: "📷", title: "Passport Size Photos", desc: "Passport Size Photos of all partners." },
              { icon: "🏢", title: "Registered Office Proof", desc: "Rented: Rent agreement + NOC. Self-owned: Utility bill/Sale Deed (must be less than 30 days)." },
              { icon: "📋", title: "Business Declaration", desc: "Declaration of the proposed Business Name and nature of business activities." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: "📋", title: "Drafted Partnership Deed", desc: "The customized and notarized legal agreement defining the firm's operations and partner roles." },
              { icon: "🆔", title: "Firm PAN Card Application", desc: "Application and receipt of the Permanent Account Number (PAN) for the Partnership Firm." },
              { icon: "💳", title: "Current Bank Account Guidance", desc: "Comprehensive guidance and documentation assistance for opening the firm's current account." },
              { icon: "🛡️", title: "Optional ROF/GST Filing", desc: "Filing for Registrar of Firms (ROF) and GST registration, if opted for in the service package." }
            ].map((item, index) => (
              <div key={index} className="p-6 bg-white rounded-xl shadow-lg border-l-4 border-green-500 h-full flex flex-col">
                <span className="text-2xl mb-3 block">{item.icon}</span>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Common Questions
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Partnership Firm Registration FAQs
            </p>
          </div>
          
          <div className="space-y-4 max-w-4xl mx-auto">
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">Is registration of a Partnership Firm mandatory?</h4>
              <p className="text-gray-600">No, registration under the Indian Partnership Act, 1932 is <strong>optional</strong>. However, an unregistered firm cannot sue outsiders for enforcing rights, which is why registration with the Registrar of Firms (ROF) is highly recommended.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">What is the liability of partners?</h4>
              <p className="text-gray-600">The liability of partners in a general partnership firm is <strong>unlimited</strong>. This means the personal assets of the partners can be used to settle the debts and obligations of the firm.</p>
            </div>
            <div className="border rounded-lg p-5 shadow-sm">
              <h4 className="font-semibold text-lg text-gray-900 mb-2">What is a Partnership Deed?</h4>
              <p className="text-gray-600">The Partnership Deed is a written agreement among the partners that outlines the terms and conditions of the partnership, including profit-sharing ratios, capital contribution, and salaries/commissions (if any).</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold text-white">
            Ready to Form Your Partnership Firm?
          </h2>
          <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
            Our experts will guide you through the seamless drafting and registration process with a fixed, affordable fee.
          </p>
          <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
            <span className="mr-2">📞</span> Consult Our Expert Today
          </a>
        </div>
      </section>
    </main>
  );
};

export default PartnershipFirm;